import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'que-number-filter',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateDirective, TranslatePipe],
  templateUrl: './number-filter.component.html',
  styleUrls: ['./number-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: NumberFilterComponent, multi: true }]
})
export class NumberFilterComponent {
  valueControl = new FormControl<number | null>(null);
  callBackFunction: Function = () => { };

  writeValue(obj: any): void {
    this.valueControl.setValue(obj, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.callBackFunction = fn;
  }

  registerOnTouched(fn: any): void {
    // throw new Error('Method not implemented.');
  }

  // Committed on blur/Enter rather than on every keystroke, so the overlay doesn't try to close
  // itself after the first digit typed (see FilterTypeComponent.ngOnInit's auto-close behavior).
  apply() {
    const value = this.valueControl.value;
    if (this.callBackFunction) {
      this.callBackFunction(value !== null && value !== undefined && value !== ('' as any) ? Number(value) : null);
    }
  }
}
